import type { ResponseContextDataPoint } from "@/api/models"

export function isResponseContextDataPointArray(data: unknown): data is ResponseContextDataPoint[] {
  return (
    Array.isArray(data) &&
    data.length > 0 &&
    typeof data[0] === "object" &&
    data[0] !== null &&
    "text" in (data[0] as Record<string, unknown>)
  )
}

export function isStringArray(data: unknown): data is string[] {
  return Array.isArray(data) && data.every((item) => typeof item === "string")
}
